
import { api_host, api_auth} from '../../common/globals/constants';
export const getResponseObjective = (currentObjectiveId,token,period) => fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalObjetivo/?objetivoId=${currentObjectiveId}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}`)
.then(response => response.json())
